import { Link } from 'react-router-dom';

/**
 * Customer accounts are closed (owner, 2026-10-01: « deploy login yes »).
 *
 * A self-made account could type ANOTHER client's phone into its profile and
 * read — through « my orders » and the phone-matching database policies — that
 * client's orders, albums and photos. Clients never need an account: their
 * order link is their way in. The worker answers GET /orders/customer/mine
 * with 410 for non-staff and migration 202 drops the phone-matching policies.
 * The team signs in at /login with accounts the owner creates.
 *
 * Guard: LoginPage.test.tsx (« customer accounts are closed »).
 */
export default function SignupPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 text-center">
          <h1 className="text-xl font-bold text-gray-900 mb-2">Les comptes clients sont fermés</h1>
          <p className="text-gray-500 text-sm">
            Vous n’avez pas besoin de compte : votre album s’ouvre avec le lien de votre commande,
            reçu sur WhatsApp.
          </p>
          <p className="text-center text-sm text-gray-500 mt-5">
            Membre de l’équipe ?{' '}
            <Link to="/login" className="text-brand-700 font-medium hover:underline">
              Se connecter
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
